import React, { Component } from "react";

import {
  Alert,
  TouchableOpacity,
  Content,
  View,
  Modal,
  Navigator,
  Text,
  TextInput,
  StyleSheet
} from "react-1app";
import { Model } from "../infra";

import * as actions from "../redux/actions.js";
import md5 from "md5";

export default class VerSenha extends Component {
  constructor(props) {
    super(props);
    this.state = {
      senha: "",
      usuario: new Model("usuario"),
      senhanova: ""
    };
    Navigator.cloneState(this);
  }

  componentDidMount() {
    this.unsubscribe = this.props.screenProps.store.subscribe(() => {
      this.setState(this.props.screenProps.store.getState());
    });
  }

  componentWillUnmount() {
    if (this.unsubscribe) this.unsubscribe();
  }

  logar() {
    if (this.props.senhaantiga == md5(this.state.senha)) {
      alert("Senha Correta");
    } else {
      alert("Senha Incorreta");
    }
  }

  trocarSenha() {
    if (!this.state.senhanova) {
      Alert.alert("Atenção", "Verifique a senha digitada");
      return;
    }
    if (this.state.senhanova.length < 4) {
      Alert.alert("Atenção", "A senha deve ter no minimo 4 caracteres.");
      return;
    }
    this.setState({ save: true });
    console.log(this.state.usuario);
    var usuario = this.state.usuario;
    usuario.senha = md5(this.state.senhanova);
    actions.usuariosUpdate(usuario.objectId, usuario, user => {
      this.setState({ save: false });
      this.state.navigator.closeModal();
    });
  }

  render() {
    return (
      <Content style={styles.senha}>
        <View style={styles.view10}>
          <View style={styles.view}>
            <Text style={styles.text}>{"Digite a nova Senha:"}</Text>
            <TextInput
              style={styles.senha1}
              value={this.state.senhanova}
              onChange={value => {
                this.setState({ senhanova: value });
              }}
              keyboardType={"default"}
              label={"Senha3"}
              onSubmitEditing={() => {
                this.trocarSenha();
              }}
              ref={v => (this.senhanova = v)}
            />
          </View>
          <View style={styles.view2}>
            <TouchableOpacity
              style={styles.button}
              onPress={() => {
                this.trocarSenha();
              }}
            >
              <Text style={styles.text2}>{"Confirmar"}</Text>
            </TouchableOpacity>
          </View>
        </View>
      </Content>
    );
  }
}

var styles = StyleSheet.create({
  senha: {
    backgroundColor: null,
    alignSelf: "stretch",
    flex: 1,
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column"
  },
  view10: {
    alignSelf: "stretch",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column",
    marginTop: 10
  },
  view: {
    alignSelf: "stretch",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column",
    padding: 20
  },
  text: {
    textAlign: "left",
    color: "rgba(0,0,0,1)",
    alignSelf: "stretch",
    fontWeight: "normal",
    marginTop: 10,
    marginLeft: 10
  },
  senha1: {
    color: "rgba(255,255,255,1)",
    alignSelf: "stretch",
    textAlign: "left",
    fontWeight: "normal"
  },
  view2: {
    alignSelf: "stretch",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    paddingBottom: 20
  },
  button: {
    alignSelf: "center",
    justifyContent: "center",
    alignItems: "center",
    height: 50,
    flexDirection: "column",
    width: 100,
    backgroundColor: "rgba(255,135,0,1)",
    borderRadius: 10
  },
  text2: {
    textAlign: "left",
    color: "rgba(255,255,255,1)",
    alignSelf: "center",
    fontWeight: "normal"
  }
});



// WEBPACK FOOTER //
// ./src/views/VerSenha.js